import { useEffect, useRef } from "react";

export function AvailableWorks() {

    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                const paragraphs = sectionRef.current.querySelectorAll("p");
                if (entry.isIntersecting) {

                    paragraphs.forEach((p, index) => {
                        setTimeout(() => {
                            p.classList.add("show");
                        }, index * 350);
                    });

                } else {
                    paragraphs.forEach((p) => {
                        p.classList.remove("show");
                    });
                }
            },
            {
                threshold: 0.3
            }
        );

        observer.observe(sectionRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <section ref={sectionRef} className="works">
            <div className="works-tittle">
                <h2 className="rainbow">Mantenimiento especializado</h2>
            </div>
            <div className="works-subcontainer">
                <p>
                    Ventilación  y extracción industrial
                </p>
                <p>
                    Sistema de recolección de polvos
                </p>
                <p>
                    Sistemas de refrigeración
                </p>
                <p>
                    Torres de enfriamiento
                </p>
                <p>
                    Sistemas VRV y VRF
                </p>
                <img src="/videos/IndustrialPipes.svg" width={640} height={480} alt="industrial animation"></img>
            </div>
        </section>
    )
}